'use strict';

const { default: i18n } = require('i18next');
const Backbone = require('backbone');
const Marionette = require('backbone.marionette');
const template = require('../../templates/footer.hbs');

const FooterView = Marionette.ItemView.extend({
  template,
  initialize: function fInit() {
    const FooterModel = Backbone.Model.extend({
      defaults: {
        copyright: i18n.t('common:copyright', { currentYear: (new Date()).getFullYear() }),
      },
    });
    this.model = new FooterModel();
  },
});

module.exports = FooterView;
